import { render, staticRenderFns } from "./AddTags.vue?vue&type=template&id=2eb433f5&"
import script from "./AddTags.vue?vue&type=script&lang=js&"
export * from "./AddTags.vue?vue&type=script&lang=js&"
import style0 from "./AddTags.vue?vue&type=style&index=0&id=2eb433f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports